import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { NavListItem } from '../models/navListItem';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  purchasePointeUrl = environment.purchasePointeUrl; 

  userPermissions;
  userRoleId;
  menu: Array<NavListItem> = [
    {
      name: 'jobs',
      to: '/jobs',
      label: 'Jobs',
      icon: 'fas fa-building',
      show: () => true,
      children: [
        { name: 'job-statuses', to: '/jobs/status', label: 'Job Status', show: () => true },
        {
          name: 'job-invoices',
          to: '/jobs/invoices',
          label: 'Invoicing',
          show: () => this.userPermissions.invoicing_list.view,
        },
        { name: 'owner-info', to: '/owner_info', label: 'Owner Info', show: () => true },
        { name: 'customers', to: '/customers', label: 'Customers', show: () => true },
      ],
    },
    {
      name: 'tools',
      to: '/tools',
      label: 'Tools',
      icon: 'fas fa-tools',
      show: () => true,
      children: [
        { name: 'tool-browser', to: '/tools', label: 'Tools Browser', show: () => true },
        { name: 'tool-models', to: '/tools/models', label: 'Models', show: () => true },
        { name: 'tool-transfers', to: '/tools/transfers', label: 'Transfers', show: () => true },
        {
          name: 'tool-inventory', to: '/tools/inventory', label: 'Inventory', show: () => this.userPermissions.tool_inventory.view
        },
      ],
    },
    {
      name: 'job-pointe',
      to: '/job-pointe/job-board',
      label: 'Job Board',
      icon: 'fas fa-tools',
      show: () => true,
      children: [
        { name: 'job-board', to: '/job-pointe/job-board', label: 'Job Board', show: () => true },
        { name: 'manage-jobs', to: '/job-pointe/manage-jobs', label: 'Manage Jobs', show: () => true },
        { name: 'employees', to: '/job-pointe/employees', label: 'Employees', show: () => true },
        { name: 'configuration', to: '/job-pointe/configuration/attributes', label: 'Configuration', show: () => true },
      ],
    },

    {
      name: 'purchasepointe',
      to: this.purchasePointeUrl,
      label: 'PurchasePointe',
      icon: 'fas fa-external-link',
      show: () => true,
      children: [],
    },
    {
      name: 'safetypointe',
      to: 'https://ae.safetypointe.com',
      label: 'SafetyPointe',
      icon: 'fas fa-external-link',
      show: () => true,
      children: [],
    },
    {
      name: 'ae-jobpointe',
      to: 'https://ae.jobpointe.com',
      label: 'AE JobPointe',
      icon: 'fas fa-external-link',
      show: () => true,
      children: [],
    },
    {
      name: 'sm-jobpointe',
      to: 'https://sm.jobpointe.com',
      label: 'SM JobPointe',
      icon: 'fas fa-external-link',
      show: () => true,
      children: [],
    },
    {
      name: 'ae-intranet',
      to: 'https://sites.google.com/andyegan.com/andyjeganintranet/home',
      label: 'Intranet',
      icon: 'fas fa-external-link',
      show: () => true,
      children: [],
    },

    {
      name: 'links',
      to: '/Links',
      label: 'Links',
      icon: 'fas fa-link',
      show: () => true,
      children: [
        { name: 'link-hh2', to: 'https://andyegan.hh2.com/', label: 'HH2', show: () => true },
        {
          name: 'link-zoho',
          to: 'https://accounts.zoho.com/signin?servicename=ZohoHome&amp;signupurl=https://www.zoho.com/signup.html',
          label: 'ZOHO',
          show: () => true,
        },
        { name: 'link-fabpro', to: 'https://fab.msuite.tech', label: 'FabPro', show: () => true },
        { name: 'link-esub', to: 'https://app.esub.com/', label: 'eSUB', show: () => true },
        { name: 'link-bim-360', to: 'https://admin.b360.autodesk.com/', label: 'BIM 360', show: () => true },
        { name: 'link-dado', to: 'https://app.projectdado.com/login', label: 'DADO', show: () => true },
      ],
    },

    {
      name: 'settings',
      to: '/settings',
      label: 'Settings',
      icon: 'fas fa-cog',
      show: () => true,
      children: [
        { name: 'settings-roles', to: '/settings/roles', icon: 'far fa-clipboard', label: 'Roles', show: () => true },
        {
          name: 'settings-users',
          to: '/settings/system_users',
          icon: 'far fa-users',
          label: 'System Users',
          show: () => true,
        },
        {
          name: 'settings-unions',
          to: '/settings/union_locals',
          icon: 'far fa-users-class',
          label: 'Union Locals',
          show: () => true,
        },
        { name: 'settings-tools', to: '/settings/tools', icon: 'far fa-tools', label: 'Tools', show: () => true },
        {
          name: 'settings-design',
          to: '/settings/design',
          icon: 'far fa-drafting-compass',
          label: 'Design',
          show: () => true,
        },
        { name: 'settings-smtp', to: '/settings/smtp', icon: 'far fa-file-signature', label: 'SMTP', show: () => true },
      ],
    },
  ];

  constructor(
    private router: Router,
    private localStorageService: LocalstorageService,
    private authService: AuthService,
  ) {
    //Get user role id and permissions on page load
    if (this.localStorageService.getItem('user')) {
      const user = JSON.parse(this.localStorageService.getItem('user'))
      this.userRoleId = user.roleId;
      this.userPermissions = JSON.parse(user.permissions);
    }
  }

  localStorageSubscription: Subscription;

  ngOnInit() {
    //Get user role id and permissions once set in local storage
    this.localStorageSubscription = this.localStorageService.storageItemSetSource.subscribe(data => {
      if (data?.key == 'user') {
        const user = JSON.parse(this.localStorageService.getItem('user'));
        this.userRoleId = user.roleId;
        this.userPermissions = JSON.parse(user.permissions);
      }
    });
  }

  ngOnDestroy() {
    this.localStorageSubscription.unsubscribe();
  }

  goToPage(page) {
    let activeElement = document.getElementsByClassName('current-page');
    activeElement[0].classList.remove('current-page');
    this.router.navigateByUrl(page);
  }
  determineJobPointeLink(): string | undefined {
    switch (true) {
      case this.userPermissions.job_board_attributes.view === 1:
        return '/job-pointe/job-board';
      case this.userPermissions.manage_jobs.view === 1:
        return '/job-pointe/manage-jobs';
      case this.userPermissions.job_pointe_employees.view === 1:
        return '/job-pointe/employees';
      case this.userPermissions.job_pointe_configuration.view === 1:
        return '/job-pointe/configuration/attributes';
      default:
        return undefined;
    }
  }
}
